module.exports = __webpack_public_path__ + "img/zoom-btn.4886f060.svg";